import { SubmissionError } from 'redux-form';

export default function convertToFormErrors({ body: response }, wrapInSubissionError = true) {
  if (!response.errors) {
    return {};
  }

  const result = response.errors.reduce((errors, item) => {
    if (item.code === 'INVALID_FIELD') {
      const { error, field, meta } = item.detail;
      const errorField = field === 'base' ? '_error' : field;
      const message = meta.human || `error.${error}`;
      return Object.assign({ [errorField]: { error: message, meta } }, errors);
    }

    const message = item.detail.meta.human || `error.${item.code}`;

    return Object.assign({ _error: { error: message, meta: {} } }, errors);
  }, {});

  return wrapInSubissionError ?
    new SubmissionError(result) :
    result;
}




// WEBPACK FOOTER //
// ./app/utils/convertToFormErrors.js